'use client'

import type { AitypesInsight } from '@polaris/api-client'
import Link from 'next/link'
import { useAmplitudeAnalytics } from '@/src/hooks/use-amplitude-analytics'

export const InsightCardLink = ({
  insight,
  children,
}: {
  insight: AitypesInsight & { highlight: boolean }
  children: React.ReactNode
}) => {
  const { ampli } = useAmplitudeAnalytics()

  const handleClick = () => {
    ampli?.insightsClickOnArticle({
      id: insight.id,
      tag: insight.tag,
      toToken: insight.subjectSelector || 'none',
      author: insight.authorName || 'none',
      isHighlight: insight.highlight || false,
    })
  }

  const popOutAnimationClasses =
    'block transition-transform duration-300 ease-out hover:scale-[1.01] will-change-transform focus-outer rounded-2xl'

  const subjectComponents = {
    none: (
      <button className={popOutAnimationClasses} onClick={handleClick}>
        {children}
      </button>
    ),
    kind: (
      <Link
        href={`/tokens?ticker=${insight.subjectSelector}`}
        prefetch
        className={popOutAnimationClasses}
        onClick={handleClick}
      >
        {children}
      </Link>
    ),
  }

  if (insight.intro) {
    return (
      <Link
        href={`/insights/${insight.id}`}
        prefetch
        className={popOutAnimationClasses}
        onClick={handleClick}
      >
        {children}
      </Link>
    )
  }

  return subjectComponents[insight.subject]
}
